import { render, staticRenderFns } from "./ListLegalQuality.vue?vue&type=template&id=6abf0500&"
import script from "./ListLegalQuality.vue?vue&type=script&lang=js&"
export * from "./ListLegalQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6abf0500')) {
      api.createRecord('6abf0500', component.options)
    } else {
      api.reload('6abf0500', component.options)
    }
    module.hot.accept("./ListLegalQuality.vue?vue&type=template&id=6abf0500&", function () {
      api.rerender('6abf0500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/batches/views/components/lists/ListLegalQuality.vue"
export default component.exports